import {
	crud,
	analysisCrud,
	getTaskLink,
	toggleTaskStatChecked,
	getResults,
	recalculateResults,
	attachMedia,
	detachMedia,
} from '@/api/tasks';

const state = {};

const getters = {};

const actions = {
	getTasks(_, params) {
		return crud.all(params);
	},
	getTask(_, taskId) {
		return crud.find(taskId);
	},
	updateTask(_, { taskId, payload }) {
		return crud.update(taskId, payload);
	},
	createTask(_, { payload }) {
		return crud.create(payload);
	},
	getTaskStats(_, params) {
		return analysisCrud.all(params);
	},
	getTaskLink(_, taskId) {
		return getTaskLink(taskId);
	},
	toggleTaskStatChecked(_, taskId) {
		return toggleTaskStatChecked(taskId);
	},
	getResults(_, taskIds) {
		return getResults(taskIds);
	},
	recalculateResults(_, taskIds) {
		return recalculateResults(taskIds);
	},
	attachMedia(_, { taskId, mediaId, conf }) {
		return attachMedia(taskId, mediaId, conf);
	},
	detachMedia(_, { taskId, mediaId }) {
		return detachMedia(taskId, mediaId);
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
